import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCamcorder = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M14 4H8C7.06812 4 6.60218 4 6.23463 4.15224C5.74458 4.35523 5.35523 4.74458 5.15224 5.23463C5 5.60218 5 6.56812 5 7.5V8.00085M6 11H13M5 8.00085C5.12187 8 5.25465 8 5.4 8H13.6C14.4401 8 14.8601 8 15.181 8.16349C15.4632 8.3073 15.6927 8.53677 15.8365 8.81901C16 9.13988 16 9.55992 16 10.4V16.8C16 17.9201 16 18.4802 15.782 18.908C15.5903 19.2843 15.2843 19.5903 14.908 19.782C14.4802 20 13.9201 20 12.8 20H6.2C5.07989 20 4.51984 20 4.09202 19.782C3.71569 19.5903 3.40973 19.2843 3.21799 18.908C3 18.4802 3 17.9201 3 16.8V10.4C3 9.55992 3 9.13988 3.16349 8.81901C3.3073 8.53677 3.53677 8.3073 3.81901 8.16349C4.08436 8.02829 4.41754 8.00489 5 8.00085ZM16 12L19.7884 9.72696C20.185 9.48902 20.3833 9.37005 20.5464 9.38525C20.6887 9.39851 20.8185 9.472 20.903 9.58716C21 9.71924 21 9.95048 21 10.413V17.587C21 18.0495 21 18.2808 20.903 18.4128C20.8185 18.528 20.6887 18.6015 20.5464 18.6147C20.3833 18.63 20.185 18.511 19.7884 18.273L16 16",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round",
		strokeLinejoin: "round"
	})
});
export default SvgCamcorder;
